"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var colors_1 = require("../ThemeProvider/colors");
__exportStar(require("@mui/material/MenuItem"), exports);
// NOTE: this component is not designed to be exported out of this library.
// prism-core use only
function MenuItemBase(props) {
    var _a;
    return (react_1.default.createElement(MenuItem_1.default, __assign({}, props, { sx: __assign(__assign({}, props.sx), { borderRadius: '5px', border: '3px solid transparent', paddingLeft: '6px', minWidth: '184px', '&.Mui-selected': __assign(__assign({}, (_a = props.sx) === null || _a === void 0 ? void 0 : _a['&.Mui-selected']), { backgroundColor: colors_1.tannerGray['50'], '&:hover': {
                    backgroundColor: colors_1.tannerGray['100'],
                }, '&:focus-visible': {
                    backgroundColor: colors_1.tannerSemantic['info']['background'],
                    border: "2px solid ".concat(colors_1.tannerWhite),
                    outline: "2px solid ".concat(colors_1.tannerBlue['500']),
                } }), '&:focus-visible': {
                backgroundColor: colors_1.tannerGray['50'],
                border: "3px solid ".concat(colors_1.tannerWhite),
                outline: "2px solid ".concat(colors_1.tannerBlue['500']),
            }, '&.MuiMenuItem-root': {
                padding: '5.5px 8px',
                '&:hover': { backgroundColor: colors_1.tannerGray['50'] },
            } }) }), props.children));
}
exports.default = MenuItemBase;
//# sourceMappingURL=MenuItemBase.js.map